import axios from 'axios';

import { Extension } from '@tiptap/core';

export const Ai = Extension.create({
    name: 'ai',

    addCommands() {
        return {
            aiComplete: () => {
                return async ({ editor }) => {
                    try {
                        const { from, to } = editor.state.selection;
                        const stub = editor.state.doc.textBetween(from, to, '\n');

                        const response = await axios.post(route('fields.ai.autocomplete'), { stub });
                        const aiResult = response.data?.text ?? '';

                        editor
                            .chain()
                            .focus()
                            .setTextSelection({ from: to, to })
                            .insertContent(' ' + aiResult)
                            .run();
                        return true;
                    } catch {
                        return false;
                    }
                };
            },

            aiGrammar: () => {
                return async ({ editor }) => {
                    try {
                        const { from, to } = editor.state.selection;
                        const stub = editor.state.doc.textBetween(from, to, '\n');

                        const response = await axios.post(route('fields.ai.grammar'), { stub });
                        const aiResult = response.data?.text ?? '';

                        editor.chain().focus().setTextSelection({ from, to }).insertContent(aiResult).run();

                        return true;
                    } catch {
                        return false;
                    }
                };
            },

            aiPrompt: () => {
                return async ({ editor }) => {
                    try {
                        const { from, to } = editor.state.selection;
                        const stub = editor.state.doc.textBetween(from, to, '\n');

                        console.log('TBD', from, to, stub);
                        return true;
                    } catch {
                        return false;
                    }
                };
            },

            aiToneOfVoice: (tone: string = 'formal') => {
                return async ({ editor }) => {
                    try {
                        const { from, to } = editor.state.selection;
                        const stub = editor.state.doc.textBetween(from, to, '\n');

                        const response = await axios.post(route('fields.ai.tone'), { stub, tone });
                        const aiResult = response.data?.text ?? '';

                        editor.chain().focus().setTextSelection({ from, to }).insertContent(aiResult).run();

                        return true;
                    } catch {
                        return false;
                    }
                };
            },

            aiTranslate: (language: string = 'english') => {
                return async ({ editor }) => {
                    try {
                        const { from, to } = editor.state.selection;
                        const stub = editor.state.doc.textBetween(from, to, '\n');

                        const response = await axios.post(route('fields.ai.translate'), { stub, language });
                        const aiResult = response.data?.text ?? '';

                        editor.chain().focus().setTextSelection({ from, to }).insertContent(aiResult).run();

                        return true;
                    } catch {
                        return false;
                    }
                };
            },
        };
    },
});
